import { render, staticRenderFns } from "./RemitCustomsReport.vue?vue&type=template&id=b9ddcbec&scoped=true&"
import script from "./RemitCustomsReport.vue?vue&type=script&lang=js&"
export * from "./RemitCustomsReport.vue?vue&type=script&lang=js&"
import style0 from "./RemitCustomsReport.vue?vue&type=style&index=0&id=b9ddcbec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ddcbec",
  null
  
)

export default component.exports